/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon24Solid = forwardRef('AttachLinkIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M.5 12A6.5 6.5 0 0 1 7 5.5h2.25a1.25 1.25 0 1 1 0 2.5H7a4 4 0 1 0 0 8h2.25a1.25 1.25 0 1 1 0 2.5H7A6.5 6.5 0 0 1 .5 12Z" }),
        React.createElement("path", { d: "M23.5 12A6.5 6.5 0 0 0 17 5.5h-2.25a1.25 1.25 0 1 0 0 2.5H17a4 4 0 0 1 0 8h-2.25a1.25 1.25 0 1 0 0 2.5H17a6.5 6.5 0 0 0 6.5-6.5Z" }),
        React.createElement("path", { d: "M7.75 10.75a1.25 1.25 0 1 0 0 2.5h8.5a1.25 1.25 0 1 0 0-2.5h-8.5Z" })));
});
